import { Link, NavLink, useLocation } from "react-router-dom";
import { useCart } from "../lib/cart";

const Header = () => {
  const { count, setOpen } = useCart();
  const location = useLocation();
  const onMembers = location.pathname.startsWith("/members");
  const onHome = location.pathname === "/";
  const onGallery = location.pathname === "/gallery";

  const catalogLinks = [
    { to: "/tees", label: "Tees", id: "nav-tees" },
    { to: "/headwear", label: "Headwear", id: "nav-headwear" },
    { to: "/hoodies", label: "Hoodies", id: "nav-hoodies" },
  ];

  const headerStyle = onHome
    ? { background: "transparent" }
    : { background: "rgba(244,242,238,0.85)" };
  const headerClass = onHome
    ? "fixed top-0 left-0 right-0 z-40"
    : "sticky top-0 z-40 backdrop-blur-md border-b hairline";

  return (
    <header className={headerClass} style={headerStyle} data-testid="site-header">
      <div className="section-pad grid grid-cols-3 items-center py-5 gap-6">
        {/* LEFT: logo + catalog links */}
        <div className="flex items-center gap-8">
          <Link to="/" className="shrink-0 block" data-testid="logo-link">
            <img
              src="https://customer-assets.emergentagent.com/job_swen-store-dev/artifacts/osfzjcp1_25.png"
              alt="Swenkville"
              className="h-9 sm:h-10 w-auto block"
            />
          </Link>
          <nav className="hidden md:flex items-center gap-8" data-testid="primary-nav">
            {catalogLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) => `nav-link-catalog ${isActive ? "active" : ""}`}
                data-testid={l.id}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>

        {/* CENTER: Gallery (isolated) */}
        <div className="hidden md:flex justify-center">
          <NavLink
            to="/gallery"
            className={() => `nav-link ${onGallery ? "active" : ""}`}
            data-testid="nav-gallery"
          >
            Gallery
          </NavLink>
        </div>

        {/* RIGHT: members + cart */}
        <div className="hidden md:flex items-center gap-8 justify-end">
          <NavLink
            to="/members"
            className={() => `nav-link ${onMembers ? "active" : ""}`}
            data-testid="nav-members"
          >
            For Members Only
          </NavLink>
          <span className="h-4 w-px bg-black/15" aria-hidden="true" />
          <button onClick={() => setOpen(true)} className="nav-link" data-testid="cart-toggle-btn">
            Cart ({count})
          </button>
        </div>

        {/* Mobile cart button on the far right of first row */}
        <button onClick={() => setOpen(true)} className="md:hidden nav-link col-start-3 justify-self-end" data-testid="cart-toggle-btn-mobile">
          Cart ({count})
        </button>
      </div>

      <div className="md:hidden section-pad pb-3 flex items-center gap-5 overflow-x-auto" data-testid="mobile-nav">
        {catalogLinks.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) => `nav-link-catalog whitespace-nowrap ${isActive ? "active" : ""}`}
            data-testid={`m-${l.id}`}
          >
            {l.label}
          </NavLink>
        ))}
        <NavLink
          to="/gallery"
          className={() => `nav-link whitespace-nowrap ${onGallery ? "active" : ""}`}
          data-testid="m-nav-gallery"
        >
          Gallery
        </NavLink>
        <span className="h-4 w-px bg-black/15 shrink-0" aria-hidden="true" />
        <NavLink
          to="/members"
          className={() => `nav-link whitespace-nowrap ml-auto ${onMembers ? "active" : ""}`}
          data-testid="m-nav-members"
        >
          For Members Only
        </NavLink>
      </div>
    </header>
  );
};

export default Header;
